import React, { useEffect, useState } from 'react'
import { WithPopover } from '@lightspeed/design-system-react'
import { useT } from '@transifex/react'
import { useSelector } from 'react-redux'
import { selectDiscountInfo } from '../../../state/selectors'
import { DiscountPopover } from './DiscountPopover'
export type Props = {
  showPopover?: boolean
  isDiscountValid: boolean
  hasPermissionToDiscount: boolean

  /** FIXME: make sure this becomes required field after migration to react for sale footer completed */
  removeSaleDiscount?: () => void
  closeDiscountPopover?: () => void
  openDiscountPopover?: () => void
}

export const SaleDiscount = (props: Props) => {
  const {
    showPopover,
    isDiscountValid,
    hasPermissionToDiscount,
    closeDiscountPopover,
    openDiscountPopover,
    removeSaleDiscount,
  } = props
  const t = useT()
  const { displayDiscount, discountIsPercentage } = useSelector(
    selectDiscountInfo
  )

  const [isOpen, setIsOpen] = useState(showPopover ?? false)
  const closePopover = () => {
    setIsOpen(false)
    if (closeDiscountPopover) {
      closeDiscountPopover()
    }
  }
  const openPopover = () => {
    setIsOpen(true)
    if (openDiscountPopover) {
      openDiscountPopover()
    }
  }

  useEffect(() => {
    setIsOpen(showPopover ?? false)
  }, [showPopover])

  const showPercentageDiscount =
    isDiscountValid && discountIsPercentage && displayDiscount !== '0'

  if (!hasPermissionToDiscount) {
    return (
      <div className="vd-text-label">{t('Discount', { _context: 'Text' })}</div>
    )
  }
  return (
    <div className="wr-sale-discount-container">
      <WithPopover direction="left">
        <div onClick={openPopover}>
          <span className="vd-text-label vd-link pro-sale-discount-link">
            {t('Discount', { _context: 'TextButton' })}
          </span>
          {showPercentageDiscount && (
            <span
              className="sale-total-line-item--sub"
              data-testid="discount_value"
            >
              {' ' + displayDiscount}%
            </span>
          )}
        </div>

        {isOpen && (
          <DiscountPopover
            closePopover={closePopover}
            removeSaleDiscount={removeSaleDiscount}
          />
        )}
      </WithPopover>
    </div>
  )
}
